$(function () {
    $('.js-rating-selectable').each(function () {
        const $stars = $(this).find('.rating__item');
        const $input = $(this).find('.js-rating-input');
        let $parent = $(this);

        $stars.on('mouseover', function () {
            const rateValue = $stars.index(this) + 1;
            $stars.removeClass('rating__item--active');
            $stars.filter((idx) => idx < rateValue).addClass('rating__item--active');
            $stars.filter((idx) => idx >= rateValue).removeClass('rating__item--active');
            $input.val(rateValue);
        });

        $stars.on('mouseout', function () {
            if (!$parent.hasClass('rating__clicked')) {
                $stars.removeClass('rating__item--active');
            }
        });

        $stars.on('click', function () {
            const rateValue = $stars.index(this) + 1;
            $stars.removeClass('rating__item--active');
            $stars.filter((idx) => idx < rateValue).addClass('rating__item--active');
            $stars.filter((idx) => idx >= rateValue).removeClass('rating__item--active');
            $input.val(rateValue);
            if ($parent.hasClass('rating__clicked')) {
                return;
            }
            $parent.addClass('rating__clicked');
            let type = $parent.data('type');
            let id = $parent.data('id');
            if (type === 'News' && +id > 0) {
                abp.services.app.jsProxy.setNewsVote(id, rateValue).done(function () {
                    console.log('rating was sent:', rateValue);
                });
            }
        });
    });
});